import { useState, useEffect, useRef, useCallback } from "react";

export const useAccordion = (isOS?: boolean) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState<string>("0px");

  const toggle = () => setIsOpen(!isOpen);

  const recalcHeight = useCallback(() => {
    if (contentRef.current) {
      setMaxHeight(`${contentRef.current.scrollHeight}px`);
    }
  }, []);

  useEffect(() => {
    if (contentRef.current) {
      setMaxHeight(isOpen ? `${contentRef.current.scrollHeight}px` : "0px");
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOS && isOpen) {
      const interval = setInterval(() => {
        recalcHeight();
      }, 100);
      return () => clearInterval(interval);
    }
  }, [isOpen, isOS, recalcHeight]);

  const getStatusColor = (status: string) => {
    const normalized = status.trim().toLowerCase();

    switch (normalized) {
      case "aguardando peças":
        return "#FAFF73";
      case "aguardando conserto":
        return "#EF5CFF";
      case "aguardando retirada":
        return "#9E8FFF";
      case "finalizada":
        return "#8DFF70";
      case "aguardando autorização de troca":
        return "#FB8022";
      case "produto trocado":
        return "#FFE4B5";
      case "aguardando analise":
        return "#FF8282";
      case "aguardando produto":
        return "#FF9933";
      case "os cancelada":
        return "#FF2200";
      default:
        return "transparent";
    }
  };

  return {
    isOpen,
    toggle,
    contentRef,
    maxHeight,
    recalcHeight,
    getStatusColor,
  };
};
